/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_VOD_OPTIMIZATION_SETTINGS',
  PUT: 'UPDATE_VOD_OPTIMIZATION_SETTINGS',
  DELETE: 'DELETE_VOD_OPTIMIZATION_SETTINGS',
  RESET: 'RESET_VOD_OPTIMIZATION_SETTINGS',
  RELOAD: 'RELOAD_VOD_OPTIMIZATION_SETTINGS',
};

export const getDraftId = () => (`vodOptimizationSettings-draft${new Date().valueOf()}`);

export const vodOptimizationSettingsReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      const id = action.payload.id ? action.payload.id : getDraftId();
      return [
        ...state,
        { ...action.payload, id },
      ];
    case types.PUT:
      return action.payload;
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.indexOf(action.item);
      newValues.splice(index, 1);
      return newValues;
    case types.RELOAD:
      return action.payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
